module.exports = __webpack_public_path__ + "img/12px-edit.0ef73408.svg";